import { Button, Collapse, ListItem, List } from '@mui/material';
import { styled } from '@mui/material/styles';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { useState } from 'react';
import { NavLink as RouterLink } from 'react-router-dom';

const PREFIX = 'NavItem';

const classes = {
  buttonLeaf: `${PREFIX}-buttonLeaf`,
};

const StyledListItem = styled(ListItem)(({ theme }) => ({
  [`& .${classes.buttonLeaf}`]: {
    padding: '8px 16px',
    justifyContent: 'flex-start',
    textTransform: 'none',
    letterSpacing: 0,
    width: '100%',
    fontWeight: theme.typography.fontWeightRegular,
    '&.depth-0': {
      fontWeight: theme.typography.fontWeightMedium,
    },
    '&.active': {
      color: theme.palette.secondary.main,
      fontWeight: theme.typography.fontWeightMedium,
    },
  },
}));

const NavButtonStyle = styled(Button)(({ theme }) => ({
  color: theme.palette.text.secondary,
  justifyContent: 'flex-start',
  width: '100%',
  textTransform: 'none',
  fontWeight: theme.typography.fontWeightMedium,
  fontSize: theme.typography.pxToRem(14),
  '&.active': {
    color: theme.palette.secondary.main,
  },
}));

const NavItem = ({ children, className, depth, href, title, ...rest }) => {
  const [open, setOpen] = useState(false);

  const handleClick = () => {
    setOpen(!open);
  };

  let paddingLeft = 8;

  if (depth > 0) {
    paddingLeft = 32 + 8 * depth;
  }

  const style = { paddingLeft };

  if (children) {
    return (
      <>
        <StyledListItem
          style={{
            padding: 0,
          }}
          button
          onClick={handleClick}
        >
          <NavButtonStyle component={RouterLink} exact="true" style={style} to={href}>
            {title}
          </NavButtonStyle>
          {open ? <ExpandLess /> : <ExpandMore />}
        </StyledListItem>
        <Collapse className={classes.collapse} in={open} timeout="auto" unmountOnExit>
          <List disablePadding>{children}</List>
        </Collapse>
      </>
    );
  }

  return (
    <ListItem className={clsx(className)} disableGutters {...rest}>
      <NavButtonStyle component={RouterLink} exact="true" style={style} to={href}>
        {title}
      </NavButtonStyle>
    </ListItem>
  );
};

NavItem.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  depth: PropTypes.number.isRequired,
  href: PropTypes.string,
  title: PropTypes.string.isRequired,
};

export default NavItem;
